module.exports = __webpack_public_path__ + "static/media/jxl.778bb761.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/jxl.png
// module id = 1779
// module chunks = 0